"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributorPricing = void 0;
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./distributor-pricing.less");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const callable_1 = require("client/components/ui/callable");
// import {
//   Distributor,
//   DistributorContact,
//   DistributorInventory,
// } from 'shared/purchase-order';
const distributorPricingColumns = [
    {
        label: "default",
        id: "default"
    },
    {
        label: "distributor name",
        id: "name"
    },
    {
        label: "ndc package",
        id: "ndc"
    },
    {
        label: "cost",
        id: "cost"
    }
];
let DistributorPricing = class DistributorPricing extends react_1.Component {
    constructor(props) {
        super(props);
        this.defaultDistributorId = null;
        this.defaultDistributorOverrideId = null;
        this.handleDistributorDefaultOverrideSelect = (distributor, index) => {
            // console.log("distributor selected is ", distributor);
            try {
                callable_1.callable(this.props.onSelect)({
                    id: distributor.id
                });
            }
            catch (e) {
                throw new Error(e);
            }
        };
        this.renderDistributorList = () => {
            const { siteDistributors = [], inventoryDistributors } = this.props;
            const siteDistributorsClean = siteDistributors.filter((sD) => !sD.deletedAt);
            return (React.createElement(list_1.MaterialList, { columns: distributorPricingColumns, 
                // rows={this.props.inventoryDistributors}
                rows: siteDistributorsClean, renderRow: this.renderDistributorListRow }));
        };
        this.renderDistributorListRow = (siteDistributor, index) => {
            const { defaultDistributorOverrideId: overrideId, defaultDistributorId: defaultId, inventoryId } = this.props;
            const { distributor } = siteDistributor;
            // const {
            //   distributor: { purchaseInventoryDistributor: distributorInventory }
            // } = siteDistributor;
            const distributorInventory = distributor.purchaseInventoryDistributor[0];
            const check = overrideId
                ? overrideId === distributor.id
                : defaultId === distributor.id;
            const isDefault = defaultId === distributor.id;
            const isOverride = overrideId === distributor.id;
            const isDefaultAndOverride = isDefault && isOverride;
            const distributorClasses = isDefaultAndOverride
                ? " distributor-item-row--default-override"
                : isOverride
                    ? " distributor-item-row--override"
                    : isDefault
                        ? " distributor-item-row--default"
                        : " distributor-item-row--none";
            return (React.createElement("div", { className: `distributor-item-row${distributorClasses}`, key: index },
                React.createElement(list_item_1.MaterialListItem, null,
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement(checkbox_1.MaterialCheckbox, { onAction: () => this.handleDistributorDefaultOverrideSelect(distributor, index), label: "", checked: check }) }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: distributor.distributor }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: distributorInventory.inventory.package }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: Number(distributorInventory.inventoryPrice).toFixed(2) }))));
        };
    }
    render() {
        // console.log(
        //   "this.props.inventoryDistributors",
        //   this.props.inventoryDistributors
        // );
        // console.log("this.props.siteDsitributor", this.props.siteDistributors);
        return (React.createElement("div", { className: "distributor-pricing-container" },
            !!this.props.siteDistributors && this.renderDistributorList(),
            this.props.inventoryDistributors &&
                this.props.inventoryDistributors.length > 0 ? (React.createElement("ul", { className: "color-code-container" },
                React.createElement("li", null,
                    React.createElement("span", { className: "color-code color-code--green" }, "DEFAULT")),
                React.createElement("li", null,
                    React.createElement("span", { className: "color-code color-code--blue" }, "OVERRIDE")),
                React.createElement("li", null,
                    React.createElement("span", { className: "color-code color-code--cyan" }, "DEFAULT AND OVERRIDE")))) : (React.createElement("div", { className: "no-available-site-distributor" }, "No available site distributor"))));
    }
};
__decorate([
    mobx_1.observable
], DistributorPricing.prototype, "inventoryDistributors", void 0);
__decorate([
    mobx_1.observable
], DistributorPricing.prototype, "defaultDistributorId", void 0);
__decorate([
    mobx_1.observable
], DistributorPricing.prototype, "defaultDistributorOverrideId", void 0);
DistributorPricing = __decorate([
    mobx_react_1.observer
], DistributorPricing);
exports.DistributorPricing = DistributorPricing;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/components/distributor-pricing/distributor-pricing.tsx
// module id = 3471
// module chunks = 0